import { FormControl } from '@angular/forms';
import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-checkbox-cell-renderer',
  templateUrl: './checkbox-cell-renderer.component.html',
  styleUrls: ['./checkbox-cell-renderer.component.scss']
})
export class CheckboxCellRendererComponent implements OnDestroy{
  params;
  checkbox: FormControl = new FormControl();
  private destroy$ = new Subject<void>();
  constructor() { }

  agInit(params): void {
    this.params = params;
    this.checkbox.setValue(this.params.value);
    if (!this.params.saveChanges) {
      this.checkbox.disable({emitEvent: false});
    }
    this.checkbox.valueChanges.subscribe(e => {
      this.params.saveChanges(this.params.data, e);
    })
  }

  stop(e: MouseEvent) {
    e.stopPropagation();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
